import React, { useEffect, useState } from "react";
import ActionBar from "../../common/ActionBar";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import AddressLabel from "../../Mis/component/Label";
import BulkDownload from "../BulkDownload";
import BulkUpdate from "../BulkUpdate";
import Rename from "./component/Rename";
import SplitAndDownload from "./component/SplitAndDownload";
import SplitAndUpload from "./component/SplitAndUpload";
import PropTypes from "prop-types";
import { makeStyles, AppBar, Tabs, Tab } from "@material-ui/core";
import _ from "lodash";
import { navigate } from "@reach/router";
import useSettings from "../../../hooks/useSettings";
import RenameImage from "./component/RenameImage";
import CreateExcel from "./component/CreateExcel";
import MergeAndUpload from "./component/MergeAndUpload";
import SplitPdf from "./component/SplitPdf";
import SplitAndRenamePOD from "./component/RenamePod";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <StyledText style={{ height: "100%" }}>{children}</StyledText>
      )}
    </div>
  );
}

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 48,
  width: "100%",
  borderRadius: 12,
  background:
    "linear-gradient(90deg,rgba(42, 123, 155, 1) 0%, rgba(87, 199, 133, 1) 50%, rgba(237, 221, 83, 1) 100%)",
  boxShadow: "0 4px 15px rgba(101, 41, 255, 0.3)",
  "& .MuiTabs-indicator": {
    height: 4,
    borderRadius: 4,
    background: "linear-gradient(90deg, #ffffff , #ffffff)",
    transition: "all 0.3s ease",
  },
  "& .MuiTabs-scroller": {
    overflowX: "auto !important",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  "& .MuiTabs-scrollButtons": {
    color: "rgba(255,255,255,0.9)",
    width: 36,
    "&.Mui-disabled": {
      opacity: 0.2,
    },
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  minWidth: 100,
  fontWeight: 700,
  fontSize: "1rem",
  color: "rgba(255,255,255,0.7)",
  transition: "color 0.3s ease",
  "&:hover": {
    color: "#ffffff",
    opacity: 1,
  },
  "&.Mui-selected": {
    color: "#ffffff",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "rgba(255,255,255,0.3)",
  },
}));

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledText = styled.article`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  overflow: auto;
`;

const useStyles = makeStyles((themes) => ({
  formLabel: {
    fontFamily: theme.fonts.primaryFontSemiBold,
    color: COLORS.COLOR_DARK,
  },
  root: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "15px 46px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  radioRoot: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 26px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  appBar: {
    color: COLORS.COLOR_DARK,
    boxShadow: "none",
    background: "transparent",
    fontFamily: theme.fonts.primaryFontBold,
    "& .MuiTabs-flexContainer": {
      justifyContent: "space-between",
      [themes.breakpoints.up(640)]: {
        justifyContent: "flex-start",
      },
    },
  },

  label: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 80,
    [themes.breakpoints.up(400)]: {
      width: "auto",
      maxWidth: 230,
    },
  },
}));

const Index = () => {
  const { selectMenuItems } = useSettings();
  const [addressLabel, setAddressLabel] = useState(false);
  const [bulkDownload, setBulkDownload] = useState(false);
  const [bulkUpdate, setBulkUpdate] = useState(false);
  const classes = useStyles();
  const [value, setValue] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [value]);

  const actions = [
    {
      text: "Address label",
      props: {
        onClick: () => setAddressLabel(true),
      },
    },
    {
      text: "Bulk Download",
      props: {
        onClick: () => setBulkDownload(true),
      },
    },
    {
      text: "Bulk Update",
      props: {
        onClick: () => setBulkUpdate(true),
      },
    },
  ];

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "dashboard":
        navigate("/dashboard/case-manager");
        break;
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <div className="paymentHistory">
        <ActionBar
          breadcrumbs={["Dashboard", "Management tools"]}
          {...{ onBreadcrumbClick, actions }}
        />

        <div className={classes.root}>
          <AppBar className={classes.appBar} position="static">
            <StyledTabs
              value={value}
              indicatorColor="primary"
              onChange={(_, newValue) => setValue(newValue)}
              aria-label="pending-action-tab"
              variant="scrollable"
              scrollButtons="auto"
            >
              <StyledTab
                label={<div className={classes.label}>{"Rename"}</div>}
                {...a11yProps(0)}
              />
              <StyledTab
                label={
                  <div className={classes.label}>{"Split and upload"}</div>
                }
                {...a11yProps(1)}
              />
              <StyledTab
                label={
                  <div className={classes.label}>{"Split and download"}</div>
                }
                {...a11yProps(2)}
              />
              <StyledTab
                label={
                  <div className={classes.label}>{"Rename for image"}</div>
                }
                {...a11yProps(3)}
              />
              <StyledTab
                label={<div className={classes.label}>{"Create Excel"}</div>}
                {...a11yProps(4)}
              />
              <StyledTab
                label={
                  <div className={classes.label}>{"Merge and Upload"}</div>
                }
                {...a11yProps(5)}
              />
              <StyledTab
                label={<div className={classes.label}>{"Split Pdf"}</div>}
                {...a11yProps(6)}
              />
              <StyledTab
                label={
                  <div className={classes.label}>{"Split and Rename POD"}</div>
                }
                {...a11yProps(7)}
              />
            </StyledTabs>
          </AppBar>

          <TabPanel value={value} index={0}>
            <Rename menuItems={selectMenuItems} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <SplitAndUpload menuItems={selectMenuItems} />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <SplitAndDownload menuItems={selectMenuItems} />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <RenameImage menuItems={selectMenuItems} />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <CreateExcel menuItems={selectMenuItems} />
          </TabPanel>
          <TabPanel value={value} index={5}>
            <MergeAndUpload menuItems={selectMenuItems} />
          </TabPanel>
          <TabPanel value={value} index={6}>
            <SplitPdf menuItems={selectMenuItems} />
          </TabPanel>
          <TabPanel value={value} index={7}>
            <SplitAndRenamePOD menuItems={selectMenuItems} />
          </TabPanel>
        </div>
        {addressLabel && (
          <AddressLabel {...{ addressLabel, setAddressLabel }} />
        )}
        {bulkDownload && (
          <BulkDownload
            {...{ bulkDownload, setBulkDownload }}
            menuItems={selectMenuItems}
          />
        )}
        {bulkUpdate && <BulkUpdate {...{ bulkUpdate, setBulkUpdate }} />}
      </div>
    </React.Fragment>
  );
};

export default Index;
